import { useEffect, useState } from 'react';

import Section from 'layouts/Section/Section';

import ContactUsForm from 'components/ContactUsForm/ContactUsForm';
import InfoList from 'components/Info/InfoList';
import ThankYouMessage from 'components/ThankYouMessage/ThankYouMessage';
import Title from 'components/Title/Title';

import styles from './ContactUs.module.scss';

const ContactUs = () => {
  const [isShowThankYouMessage, setIsShowThankYouMessage] = useState(false);

  return (
    <Section>
      <Title title="Contact Us">
        Our trusted approach. Your employment partner. Let’s work together!
      </Title>
      <div className={styles.twoColumn}>
        <InfoList />
        <ContactUsForm setIsShowThankYouMessage={setIsShowThankYouMessage} />
      </div>
      <ThankYouMessage isShowThankYouMessage={isShowThankYouMessage} />
    </Section>
  );
};

export default ContactUs;
